import { render } from "./EntranceEnglish.vue?vue&type=template&id=5d6fb761&scoped=true"
import script from "./EntranceEnglish.vue?vue&type=script&lang=js"
export * from "./EntranceEnglish.vue?vue&type=script&lang=js"

import "./EntranceEnglish.vue?vue&type=style&index=0&id=5d6fb761&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6fb761"]])

export default __exports__